import { Environment } from '../app/types/environment';

export const environment: Environment = {
  production: import.meta.env.NG_APP_PRODUCTION,
  apiUrl: import.meta.env.NG_APP_API_URL,
  websocketUrl: import.meta.env.NG_APP_WEBSOCKET_URL,
};
